<template>
  <section>
    <h1 class="text-h3 mb-8">
      Paginations
    </h1>
    <v-sheet
      class="mb-4 px-6 py-4"
      outlined
      rounded
    >
      <div class="d-flex">
        <v-checkbox
          v-model="circle"
          label="Circle"
        />
        <v-checkbox
          v-model="disabled"
          class="ml-8"
          label="Disabled"
        />
        <v-spacer />
        <v-autocomplete
          v-model="totalVisible"
          label="Total visible"
          :items="pages"
        />
      </div>
      <v-pagination
        v-model="page"
        :length="length"
        :circle="circle"
        :disabled="disabled"
        :total-visible="totalVisible"
      />
      <div class="text-center mt-4">
        <v-btn
          :disabled="length < 2"
          text
          @click="removePage"
        >
          Remove Page
        </v-btn>
        <v-divider
          class="mx-4"
          vertical
        />
        <v-btn
          text
          @click="addPage"
        >
          Add Page
        </v-btn>
      </div>
    </v-sheet>
    <h2 class="text-h4 mb-4">
      Further reading
    </h2>
    <external-link href="https://vuetifyjs.com/en/components/paginations/">
      <strong>Pagination</strong>
    </external-link>
  </section>
</template>

<script>
export default {
  name: 'ComponentsPaginations',
  data: () => ({
    length: 6,
    page: 2,
    circle: false,
    disabled: false,
    totalVisible: 6
  }),
  computed: {
    pages () {
      return Array.from({
        length: this.length
      }, (_, i) => i + 1)
    }
  },
  methods: {
    addPage () {
      this.length++
    },
    removePage () {
      this.length--
      this.page = Math.min(this.page, this.length)
      this.totalVisible = Math.min(this.totalVisible, this.length)
    }
  }
}
</script>
